var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"navbar-background"}),_c('div',{staticClass:"container-vue"},[_c('header',{staticClass:"header"},[_c('navbar')],1),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('footer',{staticClass:"footer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }